import { Directive,forwardRef } from '@angular/core';
import { AbstractControl,NG_VALIDATORS,Validator } from '@angular/forms';
import moment from 'moment';

@Directive({
  selector:
    '[validateBeforeTomorrow][formControlName],[validateBeforeTomorrow][formControl],[validateBeforeTomorrow][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BeforeTomorrowValidator),
      multi: true,
    },
  ],
  standalone: true,
})
export class BeforeTomorrowValidator implements Validator {
  tomorrow: moment.Moment = moment().add(0, 'days');
  constructor() {}

  validate(c: AbstractControl): { [key: string]: any } {
    const v = moment(c.value, 'YYYY-MM-DD');

    // value not equal
    if (v >= this.tomorrow) {
      return {
        beforeTomorrow: true,
      };
    }
    return null;
  }
}
